import React from "react";
import { useTranslation } from "react-i18next";

import "./styles/Scale.css";

import raceScale from "../medias/png/background/scale_background.png";

const Scale = () => {
  const { t } = useTranslation();

  return (
    <main className="scale">
      <h1>{t("scale.title")}</h1>
      <img
        src={raceScale}
        alt={t("scale.altRaceScale")}
        className="scale-image"
      />
    </main>
  );
};

export default Scale;
